import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function containsCharactersValidator(): ValidatorFn {
   return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      if (value.length === 0) return null;
      const isEmptyAfterTrimming = value.trim().length === 0;

      return isEmptyAfterTrimming ? { noContent: true } : null;
   };
}
